import React from "react";
import { Button, Icon } from "@blueprintjs/core";
import Image from "../Image";
import Moment from "react-moment";
import LoadingIndicator from "../../components/LoadingIndicator";

export default function UserBooking({ booking, deleteBooking, deleting_booking, user, myGuid, past_date }) {
  let show_delete_button = !past_date && (myGuid === booking.user_guid);
  const show_loader = deleting_booking === booking.guid;
  return (
    <>
      <div className="user-item">
        <div className="image user-avatar size-44">
          <Image src={user.image_url} alt={user.f_name} />
        </div>
        <div className="meta">
          <div className="name">
            {user.f_name} {user.l_name}
          </div>
          <div className="context">
            <Moment date={booking.start_time} utc={true} format="D MMMM YYYY HH:mm" />
            {" - "}
            <Moment date={booking.end_time} utc={true} format="D MMMM YYYY HH:mm" />
          </div>
        </div>
        {show_delete_button && (
          <>
            <Button
              intent="danger"
              fill={true}
              onClick={(_) => deleteBooking(booking)}
              disabled={show_loader}
              className="delete-booking-cta">
              {!show_loader && <Icon icon="trash" className="icon" iconSize="14" />}
              {show_loader && <LoadingIndicator />}
            </Button>
          </>
        )}
      </div>
    </>
  );
}
